function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 63 32 C 63 14.875 49.125 1 32 1 C 14.875 1 1 14.875 1 32 C 1 49.125 14.875 63 32 63 C 49.125 63 63 49.125 63 32 Z M 63 32 ",
    transform: "matrix(0.3125,0,0,0.3125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,50.980392%,0%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 38.275 27.8875 L 44.3875 27.8875 L 44.3875 19.6375 C 44.35 17.6 43.65 15.075 41.7375 12.625 C 39.85 10.2125 36.4625 8.1625 32.025 8.2 C 27.6 8.1625 24.2 10.2125 22.325 12.625 C 20.4125 15.075 19.7 17.6 19.6625 19.65 L 19.6625 27.8875 L 25.775 27.8875 L 25.775 19.65 C 25.75 19.1875 26.15 17.5 27.125 16.35 C 28.125 15.175 29.375 14.25 32.025 14.2125 C 34.675 14.25 35.9375 15.175 36.9375 16.35 C 37.9125 17.5 38.3125 19.1875 38.275 19.65 Z M 44.3875 35.1875 C 44.3875 35.1875 44.3875 32.3625 44.3875 29.0875 L 38.275 29.0875 C 38.275 32.3625 38.275 35.1875 38.275 35.1875 Z M 19.6625 35.1875 L 25.775 35.1875 C 25.775 35.1875 25.775 32.3625 25.775 29.0875 L 19.6625 29.0875 C 19.6625 32.3625 19.6625 35.1875 19.6625 35.1875 Z M 19.6625 35.1875 ",
    transform: "matrix(0.3125,0,0,0.3125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,50.980392%,0%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,50.980392%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 20 26.5 L 44 26.5 C 46.7625 26.5 49 28.7375 49 31.5 L 49 47.875 C 49 50.6375 46.7625 52.875 44 52.875 L 20 52.875 C 17.2375 52.875 15 50.6375 15 47.875 L 15 31.5 C 15 28.7375 17.2375 26.5 20 26.5 Z M 20 26.5 ",
    transform: "matrix(0.3125,0,0,0.3125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 35 37.0625 C 35 35.4 33.6625 34.0625 32 34.0625 C 30.3375 34.0625 29 35.4 29 37.0625 C 29 38.725 30.3375 40.0625 32 40.0625 C 33.6625 40.0625 35 38.725 35 37.0625 Z M 35 37.0625 ",
    transform: "matrix(0.3125,0,0,0.3125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 31.25 39.25 L 32.75 39.25 C 33.3 39.25 33.75 39.7 33.75 40.25 L 33.75 45 C 33.75 45.55 33.3 46 32.75 46 L 31.25 46 C 30.7 46 30.25 45.55 30.25 45 L 30.25 40.25 C 30.25 39.7 30.7 39.25 31.25 39.25 Z M 31.25 39.25 ",
    transform: "matrix(0.3125,0,0,0.3125,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/lock-circle.d1f68dde66110486704f4f44e9ae2035.svg";
export { ForwardRef as ReactComponent };